module.exports = __webpack_public_path__ + "img/zhu4.c7c74ea2.png";